export const fmtMult = (m) => (m >= 100 ? `${Math.round(m)}x` : `${m.toFixed(1)}x`);
export const clampAmt = (n) => Math.max(1000, Math.min(5000000, Math.round(n || 0)));

export function entryOf(asset, id) {
  return asset?.entries.find((e) => e.id === id) || asset?.entries[0];
}
